import { html } from '@ni/fast-element';

export const template = html`<slot></slot>`;
